<template>
    <custom-scroll class="box catalogs-panel" style="max-height: inherit;">
        <a @click="turnOffAllLayers">Скрыть все слои</a>
        <catalogs-tree :root="rootCatalog"></catalogs-tree>
    </custom-scroll>
</template>
<script>
	import CatalogsTree from './CatalogsTree'
	import {mapState} from "vuex";

	export default {
		components: {
			CatalogsTree
		},
		computed: {
			...mapState([
				'rootCatalog',
			])
		},
		methods: {
			turnOffAllLayers() {
				this.$store.dispatch('turnOffAllLayers');
			}
		}
	}
</script>
<style scoped>
    .catalogs-panel{
        width: 400px !important;
    }

    @media screen and (max-width: 768px) {
        .catalogs-panel {
            width: 250px !important;
        }
    }
</style>